// IMPORTANT: This will be the API Gateway URL you get after deployment.
// const API_BASE_URL =
//   "https://mb9c0thvd7.execute-api.ap-southeast-2.amazonaws.com/v1";

// helper tog et config values from the DOM
function getConfigValue(id, fallback = null) {
  const el = document.getElementById(id);
  return el ? el.dataset.value : fallback;
}

const API_BASE_URL = getConfigValue("ecoco-pdf-baseUrl");

if (!API_BASE_URL && document.getElementById("ecoco-customerId")) {
  console.warn(
    "Missing ecoco-pdf-baseUrl. PDF functions may not work. Check if you are logged in and AWS Setup is complete."
  );
}

/**
 * Calls a Lambda function via API Gateway and handles the response.
 * @param {string} endpoint - The name of the resource (e.g., 'generateShopifyPDF').
 * @param {string} method - The HTTP method ('GET', 'POST', etc.).
 * @param {object|null} body - The JSON body for POST requests.
 * @returns {Promise<Blob|object>} - Returns a Blob for file responses, or a JSON object for others.
 */
async function callLambda(endpoint, method = "GET", body = null) {
  try {
    const url = `${API_BASE_URL}/${endpoint}`;
    const response = await fetch(url, {
      method: method,
      // This header tells the server what kind of data we are SENDING.
      headers: {
        "Content-Type": "application/json",
      },
      ...(body && { body: JSON.stringify(body) }), // Only include the body for methods that support it (like POST).
    });

    if (!response.ok) {
      // If the server returns an error, try to parse it as JSON for a useful message.
      const errorData = await response.json().catch(() => ({}));
      throw new Error(
        `Lambda error: ${errorData.message || response.statusText}`
      );
    }
    // Check the 'Content-Type' header of the RESPONSE from the server.
    const contentType = response.headers.get("content-type") || "";

    if (contentType.includes("application/pdf")) {
      // --- Handle PDF response ---
      const buf = await response.arrayBuffer();
      const blob = new Blob([buf], { type: "application/pdf" });

      return blob;
    }

    // --- Handle JSON response ---
    return await response.json();
  } catch (error) {
    console.error(`Error calling ${endpoint}:`, error);
    throw error;
  }
}

/**
 * Specifically calls the PDF generation Lambda.
 * @param {object} selectedOrder - The full Shopify order object.
 * @returns {Promise<Blob>} A promise that resolves with the PDF file as a Blob.
 */
window.postPdf = async function (selectedOrder) {
  // Ensure your API Gateway resource name matches here.
  return await callLambda("generate-invoice", "POST", selectedOrder);
};

/**
 * Calls the capacity check Lambda.
 * @param {string} imeiValue - The IMEI or serial number to check.
 * @param {string} apiUrl - The full API endpoint URL (from config).
 * @returns {Promise<object>} - The capacity result object, or an error message object.
 */
window.fetchCapacity = async function (imeiValue, apiUrl) {
  try {
    const url = `${apiUrl}?sn=${imeiValue}`;
    const response = await fetch(url);
    if (response.status === 429) {
      return {
        errorMessage:
          "現在アクセスが集中しています。少し時間を空けて再度お試しください。",
      };
    }
    if (!response.ok) throw new Error(`API error: ${response.status}`);
    return await response.json();
  } catch (err) {
    console.error("Capacity API fetch failed:", err);
    return {
      errorMessage:
        "容量情報を取得できませんでした。時間を空けて再度お試しください。",
    };
  }
};
